/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Bfsg_TitleInputs */

const en_about_bfsg_title = /** @type {(inputs: About_Bfsg_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BFSG accessibility features`)
};

const de_about_bfsg_title = /** @type {(inputs: About_Bfsg_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funktionen zur Barrierefreiheit nach dem BFSG`)
};

const fr_about_bfsg_title = /** @type {(inputs: About_Bfsg_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fonctions d’accessibilité liées au BFSG`)
};

const es_about_bfsg_title = /** @type {(inputs: About_Bfsg_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funciones de accesibilidad orientadas al BFSG`)
};

const it_about_bfsg_title = /** @type {(inputs: About_Bfsg_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funzionalità di accessibilità orientate al BFSG`)
};

const nl_about_bfsg_title = /** @type {(inputs: About_Bfsg_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Op de BFSG gerichte toegankelijkheidsfuncties`)
};

const pl_about_bfsg_title = /** @type {(inputs: About_Bfsg_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funkcje dostępności ukierunkowane na BFSG`)
};

const fi_about_bfsg_title = /** @type {(inputs: About_Bfsg_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BFSG-suuntautuneet saavutettavuusominaisuudet`)
};

const da_about_bfsg_title = /** @type {(inputs: About_Bfsg_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BFSG-orienterede tilgængelighedsfunktioner`)
};

const sv_about_bfsg_title = /** @type {(inputs: About_Bfsg_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`BFSG-inriktade tillgänglighetsfunktioner`)
};

/**
* | output |
* | --- |
* | "BFSG accessibility features" |
*
* @param {About_Bfsg_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const about_bfsg_title = /** @type {((inputs?: About_Bfsg_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Bfsg_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_about_bfsg_title(inputs)
	if (locale === "fr") return fr_about_bfsg_title(inputs)
	if (locale === "es") return es_about_bfsg_title(inputs)
	if (locale === "it") return it_about_bfsg_title(inputs)
	if (locale === "nl") return nl_about_bfsg_title(inputs)
	if (locale === "pl") return pl_about_bfsg_title(inputs)
	if (locale === "fi") return fi_about_bfsg_title(inputs)
	if (locale === "da") return da_about_bfsg_title(inputs)
	if (locale === "sv") return sv_about_bfsg_title(inputs)
	return en_about_bfsg_title(inputs)
});